import BaseService from "../../base/base_service";
import {SYSTEM_EVENTS} from "../../events/events";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType, CashierSessionType} from "@sparkware/uc-sdk-core";
import {DialogButtonClickHandleResultEnum} from "../../../../app-react/services/dialog/dialog.service.interface";

interface IBetRejectedData {
    RejectionReasonId: number;
    GameTypeID: number;
    RealMoneyBalance: number;
    BetCurrencyCode: string;
}

const BET_REJECT_REASON_ID_MAP = {
    'Sport': 1,
    'Poker': 2,
    'PokerAndSport': 3,
};

export default class BonusAbuseParkingMoneyInSportAndPokerService extends BaseService {
    static CLASS = "BonusAbuseParkingMoneyInSportAndPokerService";

    init() {
        this._subscribe();
    }

    private _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.BONUS_ABUSE_PARKING_MONEY, this._showBonusAbuseParkingMoneyMessage)
    }

    private _getDialogContentTextTranslationKey(data: IBetRejectedData): string {
        switch(data.RejectionReasonId){
            case BET_REJECT_REASON_ID_MAP.Poker:
                if(data.RealMoneyBalance > 0) {
                    return 'BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITH_REAL_MONEY';
                } else {
                    return 'BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITHOUT_REAL_MONEY';
                }
            case BET_REJECT_REASON_ID_MAP.Sport:
                if(data.RealMoneyBalance > 0) {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITH_REAL_MONEY`;
                } else {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITHOUT_REAL_MONEY`;
                }

            case BET_REJECT_REASON_ID_MAP.PokerAndSport:
                if(data.RealMoneyBalance > 0) {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITH_REAL_MONEY`;
                } else {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITHOUT_REAL_MONEY`;
                }

        }

        return null;
    }

    private async _showBonusAbuseParkingMoneyMessage(data: IBetRejectedData): Promise<void> {


        this.serviceFactory.analyticsService().sendOrbitUserFlowEvent({
            category: 'Bonus_Availability_Popup',
            action: 'Show' ,
            label: data.GameTypeID.toString(),
            value: data.RejectionReasonId.toString()
        });


        const isGameRunning = await this.serviceFactory.gameService().isGameRunning();
        const translation = this.serviceFactory.translationProxyService();

        this.serviceFactory.dialogProxyService().showSimpleTextModal({
            title: translation.translate('BONUS_ABUSE_PARKING_MONEY_TITLE'),
            text: translation.translate(this._getDialogContentTextTranslationKey(data), {
                RealMoneyBalance: this.serviceFactory.currencyService().formatMoney(data.RealMoneyBalance)
            }),
            hideCloseButton: true,
            showPopupAboveSecondWebViewHybrid: true,
            buttons: [
                {
                    buttonPreset: "primary",
                    text: translation.translate('LOGGED_IN_CASHIER_BTN'),
                    onClick: async () => {
                        this.serviceFactory.analyticsService().sendOrbitUserFlowEvent( {
                            category: 'Bonus_Availability_Popup',
                            action: 'CTA_Click' ,
                            label: 'cashier_btn'
                        });

                        this.serviceFactory.cashierProxyService().openCashier({
                            sessionType: CashierSessionType.FullCashier,
                            channel: {
                                source: CHANNEL_SOURCE.casinoClient,
                                area: AreaType.Message,
                                element: CHANNEL_ELEMENTS.depositButton
                            }

                        });

                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                },
                {
                    buttonPreset: "secondary",
                    text: isGameRunning ? translation.translate('CLOSE_GAME') : translation.translate('CLOSE'),
                    onClick: async () => {
                        let label = 'Close Message';
                        if(isGameRunning) {
                            label = 'Close Game';
                            this.serviceFactory.gameService().closeRunningGame();
                        }

                        this.serviceFactory.analyticsService().sendOrbitUserFlowEvent( {
                            category: 'Bonus_Availability_Popup',
                            action: 'CTA_Click' ,
                            label: label
                        });
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        });
    }
}
